/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import {
  sourceRevision, targetRevision, isFileStructureShowing,
  xmlSourceFetchIsLoading, xmlSourceFetchHasErrored, xmlSourceFile,
  xmlTargetFetchIsLoading, xmlTargetFetchHasErrored, xmlTargetFile,
} from '../actions/actionCreator';

const mapStateToProps = (state) => ({
  siteId: state.siteId,
  showingFolders: state.isFileStructureShowing,
  revisionCurrent: state.revision,
  sourceRevisionCurrent: state.sourceRevision,
  targetRevisionCurrent: state.targetRevision,
  folder: state.openedFolder,
  file: state.openedFile,
});

const mapDispatchToProps = (dispatch) => ({
  sourceRevision: (rev) => dispatch(sourceRevision(rev)),
  targetRevision: (rev) => dispatch(targetRevision(rev)),
  isFileStructureShowing: (bool) => dispatch(isFileStructureShowing(bool)),
  xmlSourceFetchIsLoading: (isLoading) => dispatch(xmlSourceFetchIsLoading(isLoading)),
  xmlSourceFetchHasErrored: (hasErrored) => dispatch(xmlSourceFetchHasErrored(hasErrored)),
  xmlSourceFile: (files) => dispatch(xmlSourceFile(files)),
  xmlTargetFetchIsLoading: (isLoading) => dispatch(xmlTargetFetchIsLoading(isLoading)),
  xmlTargetFetchHasErrored: (hasErrored) => dispatch(xmlTargetFetchHasErrored(hasErrored)),
  xmlTargetFile: (files) => dispatch(xmlTargetFile(files)),
});

class Revision extends React.Component {
  openRevision(key, rev) {
    let sourceRev = 0;
    let targetRev = 0;
    if (key === 'source') {
      sourceRev = rev;
      targetRev = this.props.targetRevisionCurrent;
      if (this.props.targetRevisionCurrent === 0 || this.props.targetRevisionCurrent >= rev) {
        let previous = parseInt(this.props.id) + 1;
        if (typeof this.props.revisionCurrent[previous] === 'undefined') {
          previous = parseInt(this.props.id);
        }
        targetRev = parseInt(this.props.revisionCurrent[previous].id);
        this.props.targetRevision(targetRev);
        this.props.callDVS(
          this.props.xmlTargetFetchIsLoading, this.props.xmlTargetFetchHasErrored,
          this.props.xmlTargetFile, 'XML',
          this.props.siteId, this.props.folder, this.props.file, targetRev,
        );
      }
      this.props.sourceRevision(sourceRev);
      this.props.callDVS(
        this.props.xmlSourceFetchIsLoading, this.props.xmlSourceFetchHasErrored,
        this.props.xmlSourceFile, 'XML',
        this.props.siteId, this.props.folder, this.props.file, sourceRev,
      );
    }
    if (key === 'target') {
      targetRev = rev;
      sourceRev = this.props.sourceRevisionCurrent;
      if (rev >= this.props.sourceRevisionCurrent) {
        sourceRev = rev + 1;
        this.props.targetRevision(targetRev);
        this.props.sourceRevision(sourceRev);
        this.props.callDVS(
          this.props.xmlTargetFetchIsLoading, this.props.xmlTargetFetchHasErrored,
          this.props.xmlTargetFile, 'XML',
          this.props.siteId, this.props.folder, this.props.file, targetRev,
        );
        this.props.callDVS(
          this.props.xmlSourceFetchIsLoading, this.props.xmlSourceFetchHasErrored,
          this.props.xmlSourceFile, 'XML',
          this.props.siteId, this.props.folder, this.props.file, sourceRev,
        );
      }
      this.props.targetRevision(targetRev);
      this.props.callDVS(
        this.props.xmlTargetFetchIsLoading, this.props.xmlTargetFetchHasErrored,
        this.props.xmlTargetFile, 'XML',
        this.props.siteId, this.props.folder, this.props.file, targetRev,
      );
    }
    this.props.isFileStructureShowing(false);
    this.props.routeHandler('XML', this.props.siteId, this.props.folder, this.props.file, sourceRev, targetRev);
  }

  render() {
    const thisDate = this.props.revisionCurrent[this.props.id].date;
    let cardClassNames = thisDate.matches;
    if (this.props.sourceRevisionCurrent === this.props.revisionCurrent[this.props.id].id) {
      cardClassNames += ' activeSourceRevision';
    } else if (this.props.targetRevisionCurrent === this.props.revisionCurrent[this.props.id].id) {
      cardClassNames += ' activeTargetRevision';
    } else {
      cardClassNames += ' inactiveRevision';
    }
    cardClassNames += ' well w' + this.props.revisionCurrent[this.props.id].id.toString();
    return (
      <Card
        onClick={() => this.openRevision('source', this.props.revisionCurrent[this.props.id].id)}
        className={cardClassNames}
      >
        <Card.Body>
          <ul>
            <li className="date">
              <span>{thisDate.year}</span>
              <strong>{thisDate.month + ' ' + thisDate.date}</strong>
              {thisDate.time}
            </li>
            <li className="number">{this.props.revisionCurrent[this.props.id].id}</li>
            <li className="name"><strong>Name: </strong>{this.props.revisionCurrent[this.props.id].name}</li>
            <li className="source"><strong>Source: </strong>{this.props.revisionCurrent[this.props.id].source}</li>
            <li className="message"><strong>message: </strong>{this.props.revisionCurrent[this.props.id].message}</li>
            {this.props.revisionCurrent[this.props.id].id === this.props.revisionCurrent[0].id && this.props.page === 0 ? (
              <li className="current"><strong>CURRENT</strong></li>
            ) : null}
          </ul>
          {this.props.revisionCurrent[this.props.id].id !== this.props.revisionCurrent[0].id ? (
            <button
              onClick={(e) => {
                this.openRevision('target', this.props.revisionCurrent[this.props.id].id);
                e.stopPropagation();
              }}
              type="button"
              className="diff btn btn-primary"
            >
              Diff
            </button>
          ) : null}
        </Card.Body>
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Revision);
